export const NAME = 'Empreintes';
export const HAS_LOGO_APP = false;
export const MENUS_MODULE_ENABLED = true;
export const ARTICLES_MODULE_ENABLED = true;
export const MEDIAS_MODULE_ENABLED = false;
export const USER_ADD_DB_PRODUCT = true;
export const FEEDBACK_MODULE_ENABLED = true;
export const BALANCE_ALERT_MODULE_ENABLED = true;
